<script setup lang="ts">
    import { InputRow, Combobox } from '@/components/ui/form';
    import { useEconomicAccountData } from '@/composables/useEconomicAccountData';
    import { usePage } from '@inertiajs/vue3';
    import type { SharedData, ViiaAccount } from '@/types';
    import { useJournalsData } from '@/composables/useJournalsData';
    import { useCashBookTypesData } from '@/composables/useCashBookTypeData';
import { computed } from 'vue';
    
    const page = usePage<SharedData>();
    const companyId = computed(() => page.props.auth.user.selected_company_id);

    defineProps<{
        form: any;
        dbAccount: ViiaAccount;
    }>();

    const { journals, isLoadingJournals } = useJournalsData(companyId.value);
    const { cashBookTypes, isLoadingCashBookTypes } = useCashBookTypesData();
    const { accounts, isLoadingAccounts } = useEconomicAccountData(companyId.value);
</script>

<template>
    <div class="flex flex-col gap-3">
        <InputRow
            v-if="!dbAccount.contra_account_nr"
            :form="form"
            name="contra_account_nr"
            label="viia.accounts.attach"
        >
            <Combobox
                v-model="form.contra_account_nr"
                :options="accounts"
                :translate="false"
                :placeholder="$t('viia.accounts.attach')"
                label-by="number_and_name"
                value-by="accountNumber"
                :loading="isLoadingAccounts"
                :show-remove-button="false"
            />
        </InputRow>
        <InputRow
            :form="form"
            name="cashbook_id"
            label="viia.transactions.cashbook"
        >
            <Combobox
                v-model="form.cashbook_id"
                :options="journals"
                :translate="false"
                :placeholder="$t('viia.transactions.cashbook')"
                label-by="name"
                value-by="number"
                :loading="isLoadingJournals"
                :show-remove-button="false"
            />
        </InputRow>
        <InputRow
            :form="form"
            name="cashBookType"
            label="viia.transactions.cashbook-type"
        >
            <Combobox
                v-model="form.cashBookType"
                :options="cashBookTypes"
                :translate="false"
                :placeholder="$t('viia.transactions.cashbook-type')"
                label-by="text"
                value-by="id"
                :loading="isLoadingCashBookTypes"
                :show-remove-button="false"
            />
        </InputRow>
    </div>
</template>
